// extracted by mini-css-extract-plugin
module.exports =  {"PremiumTable":"VVMdfZn_0gpccsEmDCQ9"};